"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _firebase = _interopRequireDefault(require("../../../../@api/appcenter/firebase.config"));
var _hooks = require("../../../../@hooks");
var _swiper = require("swiper");
var _material = require("@mui/material");
var _Icon = _interopRequireDefault(require("../../../Icon"));
var _i18n = _interopRequireDefault(require("../../../../@i18n"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
var _index = require("../../index");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* IF YOU ARE USING NODE 16 */
// import { Pagination } from 'swiper/modules'
// import { Swiper, SwiperSlide } from 'swiper/react'

/* IF YOU ARE USING NODE 10 */

var appcenterFirestore = _firebase["default"].firestore();
var domainCollection = appcenterFirestore.collection('portalDomains');
var companyCollection = appcenterFirestore.collection('company');

/**
 * @typedef CompanyListProps
 * @type {{
 *     loading: boolean;
 * 		 setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
 * }}
 */

/** @param {CompanyListProps} props */
var CompanyList = function CompanyList(_ref) {
  var loading = _ref.loading,
    setIsLoading = _ref.setIsLoading;
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    rememberAccess = _useState4[0],
    setRememberAccess = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    companiesSnapshot = _useState6[0],
    setCompaniesSnapshot = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    companiesLoading = _useState8[0],
    setCompaniesLoading = _useState8[1];
  var _useWindowSize = (0, _hooks.useWindowSize)(),
    _useWindowSize2 = (0, _slicedToArray2["default"])(_useWindowSize, 1),
    screenWidth = _useWindowSize2[0];
  var searchRef = (0, _react.useRef)(null);
  var slidesPerView = (0, _react.useMemo)(function () {
    if (screenWidth <= 420) {
      return 3;
    } else if (screenWidth <= 720) {
      return 4;
    } else {
      return 6;
    }
  }, [screenWidth]);
  var filteredCompanies = (0, _react.useMemo)(function () {
    var sorteredCompanies = companiesSnapshot.map(function (doc) {
      return doc.data();
    }).sort(function (a, b) {
      return (a.name || a.fantasyName).localeCompare(b.name || b.fantasyName);
    });
    if (!search) return sorteredCompanies;
    return sorteredCompanies.filter(function (company) {
      var nameLowerCase = (company.name || company.fantasyName).toLowerCase();
      var searchLowerCase = search.toLowerCase();
      return nameLowerCase.includes(searchLowerCase);
    });
  }, [search, companiesSnapshot]);
  var getCompanies = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var query, lastDoc, _yield$query$get, docs;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setCompaniesLoading(true);
            _context.prev = 1;
            query = companyCollection.where('deleted', '==', false).where('portal.domain', '!=', '');
            lastDoc = companiesSnapshot[companiesSnapshot.length - 1];
            if (lastDoc) {
              query = query.startAfter(lastDoc);
            }
            query = query.limit(20);
            _context.next = 8;
            return query.get();
          case 8:
            _yield$query$get = _context.sent;
            docs = _yield$query$get.docs;
            setCompaniesSnapshot(function (prevState) {
              return [].concat((0, _toConsumableArray2["default"])(prevState), (0, _toConsumableArray2["default"])(docs));
            });
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            console.log('ERROR getCompanies: >=>', _context.t0);
          case 16:
            _context.prev = 16;
            setCompaniesLoading(false);
            return _context.finish(16);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 13, 16, 19]]);
    }));
    return function getCompanies() {
      return _ref2.apply(this, arguments);
    };
  }();
  var openPortal = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(company) {
      var doc, portalDomain, base_domain, domain;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            setIsLoading(true);
            _context2.next = 4;
            return domainCollection.doc(company.portal.domain).get();
          case 4:
            doc = _context2.sent;
            portalDomain = doc.data();
            base_domain = portalDomain.domain === 'localhost:3000' ? 'http://' : 'https://';
            domain = "".concat(base_domain).concat(portalDomain.domain);
            if (rememberAccess) {
              localStorage.setItem(_index.REMEMBER_KEY, JSON.stringify({
                remember: true,
                domain: domain
              }));
            }
            window.open(domain, '_self');
            _context2.next = 15;
            break;
          case 12:
            _context2.prev = 12;
            _context2.t0 = _context2["catch"](0);
            console.log('ERROR openPortal : >=>', _context2.t0);
          case 15:
            _context2.prev = 15;
            setIsLoading(false);
            return _context2.finish(15);
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 12, 15, 18]]);
    }));
    return function openPortal(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleRememberAccess = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(event) {
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            setRememberAccess(!!event.target.checked);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleRememberAccess(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    var handleKeySearch = function handleKeySearch(event) {
      if (event.ctrlKey && event.key === '/') {
        event.preventDefault();
        searchRef.current.focus();
      }
    };
    window.addEventListener('keydown', handleKeySearch);
    return function () {
      window.removeEventListener('keydown', handleKeySearch);
    };
  }, []);
  (0, _react.useEffect)(function () {
    getCompanies().then();
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _stylesModule["default"].Content
  }, !loading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    color: "white",
    variant: "h5",
    my: 4
  }, (0, _i18n["default"])('Defina o portal de acesso')), /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    onChange: handleRememberAccess,
    className: _stylesModule["default"].ControlCheckbox,
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, null),
    label: "Lembrar meu acesso"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _stylesModule["default"].Input
  }, /*#__PURE__*/_react["default"].createElement(_material.TextField, {
    inputRef: searchRef,
    onChange: function onChange(event) {
      return setSearch(event.target.value);
    },
    variant: "standard",
    placeholder: (0, _i18n["default"])('Pesquisar (Ctrl+/)'),
    InputProps: {
      startAdornment: /*#__PURE__*/_react["default"].createElement(_material.InputAdornment, {
        position: "start"
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        icon: "faSearch"
      })),
      disableUnderline: true
    },
    fullWidth: true
  })), /*#__PURE__*/_react["default"].createElement(_swiper.Swiper, {
    pagination: {
      bulletClass: _stylesModule["default"].Bullet,
      clickable: true,
      dynamicBullets: true,
      dynamicMainBullets: 10
    },
    spaceBetween: 16,
    slidesPerView: slidesPerView,
    modules: [_swiper.Pagination],
    className: _stylesModule["default"].PortalList
  }, filteredCompanies === null || filteredCompanies === void 0 ? void 0 : filteredCompanies.map(function (company) {
    var _company$meta, _company$meta$whitela, _company$meta2, _company$meta2$whitel, _company$meta3, _company$meta3$whitel;
    return /*#__PURE__*/_react["default"].createElement(_swiper.SwiperSlide, {
      key: company.uid,
      className: _stylesModule["default"].PortalInfo
    }, /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
      title: company.name || company.fantasyName,
      placement: "bottom"
    }, !!(company !== null && company !== void 0 && (_company$meta = company.meta) !== null && _company$meta !== void 0 && (_company$meta$whitela = _company$meta.whitelabel) !== null && _company$meta$whitela !== void 0 && _company$meta$whitela.logo) && /*#__PURE__*/_react["default"].createElement("img", {
      src: company === null || company === void 0 ? void 0 : (_company$meta2 = company.meta) === null || _company$meta2 === void 0 ? void 0 : (_company$meta2$whitel = _company$meta2.whitelabel) === null || _company$meta2$whitel === void 0 ? void 0 : _company$meta2$whitel.logo,
      alt: "Portal"
    }), !(company !== null && company !== void 0 && (_company$meta3 = company.meta) !== null && _company$meta3 !== void 0 && (_company$meta3$whitel = _company$meta3.whitelabel) !== null && _company$meta3$whitel !== void 0 && _company$meta3$whitel.logo) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "faBuilding"
    })), /*#__PURE__*/_react["default"].createElement("button", {
      className: _stylesModule["default"].PortalInfoButton,
      onClick: function onClick() {
        return openPortal(company);
      }
    }, "ENTRAR")));
  }), /*#__PURE__*/_react["default"].createElement(_swiper.SwiperSlide, {
    className: _stylesModule["default"].PortalInfoPlus,
    onClick: function onClick() {
      if (!companiesLoading) {
        getCompanies();
      }
    }
  }, !companiesLoading && /*#__PURE__*/_react["default"].createElement("div", {
    className: _stylesModule["default"].IconPlus
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faArrowsRotate"
  })), companiesLoading && /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, null)))));
};
var _default = CompanyList;
exports["default"] = _default;